'use client';

import { usePathname } from 'next/navigation';
import { useAppContext } from '@/contexts/AppContext';
import { SITE_ORIGIN } from '@/globalConstants';
import { breadcrumbTrail, ownsBreadcrumbJsonLd } from '@/lib/breadcrumbs';

const DOMAIN = SITE_ORIGIN;

// Emits a single BreadcrumbList JSON-LD per page (SEO T3.2). Rendered once from
// the (pages) layout, so it doesn't depend on how many visual breadcrumbs a
// template renders (rashifal shows two) — this always
// lands exactly once in the server HTML.
export default function BreadcrumbJsonLd() {
  const pathname = usePathname() || '/';
  const { isAppView } = useAppContext();

  const pages = pathname.split('/').filter(Boolean);

  // Skip the home page (trivial single crumb), the app-only Kundali webview, and
  // in-app webviews (where the visible breadcrumb is hidden).
  if (isAppView || pages.length === 0 || pathname.startsWith('/kundali') || ownsBreadcrumbJsonLd(pathname)) return null;

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbTrail(pathname).map(({ name, href }, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name,
      item: href === '/' ? DOMAIN : `${DOMAIN}${href}`,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
    />
  );
}
